// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loading-stub {
    position: relative;
    overflow: hidden;
}
#loading-stub::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 20%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0.4) 80%, rgba(255, 255, 255, 0) 100%);
    animation: waves 1s ease-in-out infinite;
    animation-duration: 1s;
}
@keyframes waves {
    0% {
        transform: translate3d(-100%, 0, 0);
    }
    100% {
        transform: translate3d(100%, 0, 0);
    }
}
`, "",{"version":3,"sources":["webpack://./layers/front-layer/src/main/webapp/static-content/_versionedByRelease_/js/widgets/ReactApp/loading-stub.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,uLAAuL;IAEvL,wCAAwC;IACxC,sBAAsB;AAC1B;AACA;IACI;QACI,mCAAmC;IACvC;IACA;QACI,kCAAkC;IACtC;AACJ","sourcesContent":["#loading-stub {\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n#loading-stub::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 20%, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0.4) 80%, rgba(255, 255, 255, 0) 100%);\r\n    -webkit-animation: waves 1s ease-in-out infinite;\r\n    animation: waves 1s ease-in-out infinite;\r\n    animation-duration: 1s;\r\n}\r\n@keyframes waves {\r\n    0% {\r\n        transform: translate3d(-100%, 0, 0);\r\n    }\r\n    100% {\r\n        transform: translate3d(100%, 0, 0);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
